export default "__VITE_ASSET__BRPlOI8v__"